import { Injectable } from '@angular/core';
import { Request, Headers, Response } from '@angular/http';
import { HttpClient } from '../../../services/http.service';
import { AppConstants } from '../../../app.constants';
import { Observable } from 'rxjs/Rx';
import { LocalStorageService } from 'ng2-webstorage';

@Injectable()
export class NoticeboardService {
    private firebaseUrl: string;
    private schoolId: string;
    private token: string;
    public selectedSection: any;
    public selectedStandard: any;
    constructor(private httpClient: HttpClient, private appConstants: AppConstants, private localStorage: LocalStorageService) {
        this.firebaseUrl = this.localStorage.retrieve('Firebase');
        this.schoolId = this.localStorage.retrieve('SchoolId');
    }
    //manage-user by id
    public getUserdetailbyId(userId){
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.getSchoolUserById+'?id='+userId+'&schoolid='+this.localStorage.retrieve('SchoolId');
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }
    //calling sectional grades
    public getSections(): Observable<Response> {
        var url: string = '' + this.appConstants.baseUrl + this.appConstants.sectionalgrade + '/' + this.localStorage.retrieve('SchoolId');
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }
    public getParentsByClass(sectionName, standardName): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetParentsBySection + '?token=' +this.localStorage.retrieve('Token')+ '&standard=' + standardName + '&section=' + sectionName;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError)
    }


  public getParentsByClassFilterQuanta(academicYear, sectionName, standardName): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'GetParentsListStudentView' +
      '?token=' +this.localStorage.retrieve('auth_token')+
      '&academicyearid=' + academicYear +
      '&nuofRows=' + 100 +
      '&pageNumber=' + 1 +
      '&searchstring=' + '' +
      '&standard=' + standardName +
      '&section=' + sectionName;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError)
  }



  public getParentsByClassFilter(academicYear, sectionName, standardName): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'GetParentsListStudentView' +
      '?token=' +this.localStorage.retrieve('token')+
      '&academicyearid=' + academicYear +
      '&nuofRows=' + 100 +
      '&pageNumber=' + 1 +
      '&searchstring=' + '' +
      '&standard=' + standardName +
      '&section=' + sectionName;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError)
  }


  public getBulkNBMessages(schoolUserId, startNBDate, endNBDate): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'GetBulkNBMessages' +
      '?schoolUserId=' +schoolUserId+
      '&startNBDate=' + startNBDate +
      '&endNBDate=' + endNBDate;
    return this.httpClient.Get(url)
      .map(this.extractData)
      .catch(this.handleError)
  }


  public getBulkSBMessages(value) {
    let url: string = '' + this.appConstants.baseUrl + '/GetSBMessages';
    return this.httpClient.Post(url, value)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public deleteBulkSBMessages(value) {
    let url: string = '' + this.appConstants.baseUrl + '/DeleteSBMessages';
    return this.httpClient.Post(url, value)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deleteBulkNBMessages(schoolUserId, startNBDate, endNBDate): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'DeleteBulkNBMessages' +
      '?schoolUserId=' +schoolUserId+
      '&startNBDate=' + startNBDate +
      '&endNBDate=' + endNBDate;
    return this.httpClient.Delete(url)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public deleteSemester(semesterId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'DeleteSemester' + '?id=' +semesterId;
    return this.httpClient.Delete(url)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public deleteExam(examId): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + 'DeleteExam' + '?id=' +examId;
    return this.httpClient.Delete(url)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getClassSectionMap(): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + this.appConstants.GetstandardsectionMapping + '?Schoolid=' + this.schoolId;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }


    public getClassSectionMapStudentList(selectedlevel): Observable<Response> {
      this.schoolId = this.localStorage.retrieve('SchoolId');
      let url: string = '' + this.appConstants.baseUrl + 'GetLevelStandardSectionMapping' + '?Schoolid=' + this.schoolId +'&LevelId=' + selectedlevel;
        return this.httpClient.Get(url)
            .map(this.extractData)
            .catch(this.handleError);
    }

    // public postFile(imagePayload): Observable<Response> {
    //     let url: string = '' + this.appConstants.fileuploadUrl + this.appConstants.uploadFile;
    //     return this.httpClient.Post(url, imagePayload)
    //         .map(this.extractData)
    //         .catch(this.handleError)
    // }
    public postFile(imagePayload): Observable<Response> {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.uploadFile;
        return this.httpClient.Post(url, imagePayload)
            .map(this.extractData)
            .catch(this.handleError)
    }
    public sendMessage(value) {
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.PostNoticeBoardMsg;
        return this.httpClient.Post(url, value)
            .map(this.extractData)
            .catch(this.handleError);
    }

    public sendNBnotification(value){
        let url: string = '' + this.appConstants.baseUrl + this.appConstants.SendNBMessageNotification;
        return this.httpClient.Post(url, value)
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        let err = JSON.parse(error._body);
        return Observable.throw(err);
    }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/noticeboard/noticeboard/noticeboard.service.ts